import { useState, useEffect } from 'react';
import { SessionWrapper } from '../types';

export const useAuth = () => {
    const [session, setSession] = useState<SessionWrapper | null>(null);
    const [isLoadingAuth, setIsLoadingAuth] = useState(true);

    useEffect(() => {
        const checkSession = () => {
            const savedSession = localStorage.getItem('mitifresh_session');
            if (savedSession) {
                try {
                    setSession(JSON.parse(savedSession));
                } catch (e) {
                    setSession(null);
                }
            } else {
                setSession(null);
            }
            setIsLoadingAuth(false);
        };

        // Check initially
        checkSession();

        // Listen for cross-tab login/logout events
        window.addEventListener('storage', checkSession);
        // Listen for same-tab login/logout (localStorage writes don't fire 'storage' in the writing tab)
        window.addEventListener('mitifresh-auth-change', checkSession);

        return () => {
            window.removeEventListener('storage', checkSession);
            window.removeEventListener('mitifresh-auth-change', checkSession);
        };
    }, []);


    const logout = () => {
        localStorage.removeItem('mitifresh_session');
        localStorage.removeItem('mitifresh_basket');
        window.dispatchEvent(new Event('mitifresh-auth-change'));
        window.location.hash = '#/';
    };

    return { session, isLoadingAuth, logout };
};